import { Typography } from "@mui/material";
import ModalSimpleButton from "../../components/Modal/ModalSimpleButton";
import ModalTwoButtons from "../../components/Modal/ModalTwoButtons";
import { ModalState } from "./modalTypes";

interface ActionModalProps {
  open: boolean;
  modal: ModalState;
  onClose: () => void;
}

const ActionModal = ({ open, modal, onClose }: ActionModalProps) => {
  if (!open) {
    return null;
  }

  if (modal.kind === "status") {
    return (
      <ModalSimpleButton
        title={modal.title}
        buttonText="Ok"
        buttonAction={onClose}
        setOpen={onClose}
        open={open}>
        <Typography style={{ padding: "0 16px", fontSize: 18, textAlign: "center" }}>
          {modal.message}
        </Typography>
      </ModalSimpleButton>
    );
  }

  return (
    <ModalTwoButtons
      title={modal.title}
      button1Text="Yes"
      button1Action={modal.onConfirm}
      isButton1Disabled={modal.isConfirmDisabled ?? false}
      button2Text="No"
      button2Action={modal.onCancel}
      isButton2Disabled={modal.isCancelDisabled ?? false}
      open={open}
      setOpen={modal.onCancel}
      setClose={modal.onCancel}>
      <Typography style={{ padding: "0 16px", fontSize: 18, textAlign: "center" }}>
        {modal.message}
      </Typography>
    </ModalTwoButtons>
  );
};

export default ActionModal;
